// extracted by mini-css-extract-plugin
module.exports = {"payment-info":"style_payment-info__1JAzP","file-upload":"style_file-upload__PKtl8"};